<template>
  <the-1-column-layout>
    <div class="text-center"><button v-on:click="addWarrantyRegistration" class="btn btn--white">{{loc('addWarrantyRegistration')}}</button></div><br />
    <v-client-table :columns="columns" :data="filteredData" :options="options">
      <router-link slot="uuid" slot-scope="props" :to="{ name: 'warranty-registration', params: { id: props.row.uuid }}">{{props.row.uuid}}</router-link>
    </v-client-table>
    <modal-warranty-registration ref="addWarrantyRegistrationModal" :modal-mode="'add'"></modal-warranty-registration>
    <div class="text-center">
        <div class="spinner"></div>
    </div>
  </the-1-column-layout>
</template>

<script>

import VForm from './v-form.vue';
import ModalWarrantyRegistration from './modal-warranty-registration.vue';
import $ from 'jquery';

export default {
  name: 'ViewWarrantyRegistrations',
  components: {
    'modal-warranty-registration': ModalWarrantyRegistration,
    'v-form': VForm
  },
  data: function () {
    return {
      formData: {},
      formErrors: {},
      searchText: '',
      searchColumns: ['uuid', 'serialNumber', 'deliveryDateWarranty', 'sellerStore'],
      columns: ['uuid', 'serialNumber', 'deliveryDateWarranty', 'sellerStore'],
      sortable: ['uuid', 'serialNumber', 'deliveryDateWarranty', 'sellerStore'],
      filterable: ['uuid', 'serialNumber', 'deliveryDateWarranty', 'sellerStore'],
    }
  },
  computed: {
    options() {
      return {
        filterable: false,
        headings: {
          uuid: this.loc('warrantyRegistrationId'),
          serialNumber: this.loc('serialNumber'),
          deliveryDateMachine: this.loc('dateAddedMachine'),
          deliveryDateWarranty: this.loc('deliveryDateWarranty'),
          sellerStore: this.loc('registeredBy'),
        },
        texts: {
            noResults: this.loc('noMatchingResults')
        }
      }
    },

    warrantyRegistrations() {
      return this.$store.state.warrantyRegistrations.map(warrantyRegistration => {
        return {
          uuid: warrantyRegistration.uuid,
          serialNumber: warrantyRegistration.serialNumber,
          deliveryDateWarranty: warrantyRegistration.dateAdded && warrantyRegistration.dateAdded.formatted,
          sellerStore: warrantyRegistration.sellerStore,
        }
      });
    },

    filteredData() {
      const self = this;
      const searchText = this.$store.state.subheader.searchText; // Use subheader search input for searching
      const data = this.warrantyRegistrations;

      if(searchText) {
        const searchRegEx = new RegExp(searchText, 'i')

        return data.filter(function (item) {
          for(let i=0, l=self.searchColumns.length; i<l; i++) {
            const column = self.searchColumns[i];

            if(searchRegEx.test(item[column])) {
              return true;
            }
          }
          return false;
        });
      }
      return data;
    }
  },
  methods: {
    addWarrantyRegistration() {
      this.$refs.addWarrantyRegistrationModal.show();
    }
  },
  mounted: function () {
    this.$store.dispatch('getWarrantyRegistrations')
                .then(() => {
                    $('.spinner').hide();
                });


    this.$store.commit('setSubheader', {
      subtitle: '',
      title: this.loc('components.warrantyRegistrations.subheaderTitle'),
      description: '',
      searchEnabled: true
    });
  }
}
</script>
